import { Component } from 'react'
import { connect } from 'react-redux'
import WPAPI from 'wpapi'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { rootPath } from 'lib/Utils'
import { toggleBlockUI } from 'store/blockUI'

class Contact extends Component {
  componentDidMount () {
    this.props.toggleBlockUI(true)
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
      // routes: apiRootJSON.routes
    })

    wp.locations = wp.registerRoute('wp/v2', 'location')

    let contentObject = { type: 'contact', 'title': 'Contact' }

    wp.locations().order('asc').orderby('menu_order').get()
      .then((data) => {
        this.props.toggleBlockUI(false)
        contentObject.locations = data
        this.props.updateContent(contentObject)
      })
      .catch((error) => {
        console.warn(error)
        this.props.toggleBlockUI(false)
      })
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  toggleBlockUI: (block) => toggleBlockUI(block)
}

Contact.propTypes = {
  updateContent: PropTypes.func,
  toggleBlockUI: PropTypes.func
}

export default connect(null, mapDispatchToProps)(Contact)



// WEBPACK FOOTER //
// ./src/routes/Contact/index.js